import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'playerSeekbar',
})
export class PlayerSeekbarPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  transform(max: number, value: number, reference?: any): unknown {
    if (max <= 0) return 0;
    const seekValue = value / max;
    if (!reference) {
      if (value > max) return 1;
      return seekValue;
    }
    return seekValue * (reference?.offsetWidth || 0);
  }
}
